export function checkFalsyValues(obj: Record<string, string>) {
	return !Object.values(obj).some((el) => !el);
}
